import type { Root } from 'react-dom/client';
import { createRoot } from 'react-dom/client';
import React from 'react';

import type { Extension } from '@interhyp/platform-plugin';
import type { Presets } from '@interhyp/platform-tealium';

import type { ModuleName } from '../types/ModuleName.js';
import { MFError } from '../errors/MFError.js';

import { AppShell } from './components/AppShell.js';

export interface RenderArgs {
  container: Element | (() => Element);
  name: ModuleName;
  props: unknown;
  provide?: Extension[];
  tealium: Presets;
}

const rootCache = new WeakMap<Element, Root>();

export const render = async ({ container, name, props, provide, tealium }: RenderArgs) => {
  const container_ = typeof container === 'function' ? container() : container;

  if (!container_) {
    throw new MFError(`Missing slot`, name);
  }

  let root = rootCache.get(container_);

  if (!root) {
    root = createRoot(container_, { identifierPrefix: 'shell-' });
    rootCache.set(container_, root);
  }

  root.render(<AppShell name={name} props={props} provide={provide} tealium={{ presets: tealium }} />);

  return () => root.unmount();
};
